import script from "./Settings.vue?vue&type=script&setup=true&lang=ts"
export * from "./Settings.vue?vue&type=script&setup=true&lang=ts"

import "./Settings.vue?vue&type=style&index=0&id=634ad3f4&scoped=true&lang=css"
import "./Settings.vue?vue&type=style&index=1&id=634ad3f4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-634ad3f4"]])

export default __exports__